import React from 'react';
import LinkButton from 'components/shared/LinkButton';
import { IconNews } from '@seismic/mantle';
import { Text, TEXT_VARIANTS } from 'ui/Typography';

const PostToChannelLinkButton = props => {
  const { channelLink } = props;

  const openInNewTab = url => {
    const newWindow = window.open(url, '_blank', 'noopener,noreferrer');
    if (newWindow) newWindow.opener = null;
  };

  const onClickUrl = url => {
    return () => openInNewTab(url);
  };

  return (
    <>
      <LinkButton
        label={t('common.post_to_channels')}
        type="primary"
        onClick={onClickUrl(channelLink)}
        className="mh-34 mr-4 ml-4"
      >
        <Text
          className="d-f ai-c c-gray-dark fz-13"
          variant={TEXT_VARIANTS.BODY_LINK}
        >
          <IconNews size={16} className="ml-4 pr-4" />
          <div className="pl-4">{t('common.post_to_channels')}</div>
        </Text>
      </LinkButton>
    </>
  );
};

export default PostToChannelLinkButton;
